<template>
  <div class="cont">
    <div v-if="!showBannerList.length" class="banner">
      <img
        v-if="mainBanner"
        :src="mainBanner"
        class="banner-img"
        alt="main-banner"
      />
    </div>
    <div
      class="banner banner-swiper-container swiper-container"
      v-show="showBannerList.length > 0"
    >
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in showBannerList"
          :key="index"
        >
          <img
            :src="item.bannerUrl"
            class="banner-img j-banner"
            :class="{ hover: item.redirectUrl }"
            :pointValue="item.redirectUrl"
            alt="banner-img"
            @click="jumpLink(item.redirectUrl)"
          />
        </div>
      </div>
      <div class="swiper-pagination"></div>
      <div v-if="bannerTitle" class="banner-text" @click="jumpLink(bannerLink)">
        {{ bannerTitle }}
      </div>
    </div>
  </div>
</template>

<script>
import MarqueeText from 'vue-marquee-text-component';
import { mapState, mapGetters } from 'vuex';
import Swiper from 'swiper';
import { sdkOpenLink } from '@utiles/officialStore/sdkCtrl';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
export default {
  data() {
    return {
      swiper: null,
      activeIndex: 0
    };
  },
  components: {
    MarqueeText
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      gameId: state => state.gameId,
      indexBannerList: state => state.activity.indexBannerList,
      picList: state => state.page.picList,
      isLandscape: state => state.page.isLandscape
    }),
    ...mapGetters(['gameInfoConfig']),
    mainBanner() {
      return this.picList?.mainbanner;
    },
    bannerTitle() {
      return this.showBannerList[this.activeIndex]?.bannerTitle;
    },
    bannerLink() {
      return this.showBannerList[this.activeIndex]?.redirectUrl;
    },
    showBannerList() {
      // 判断列表每个banner.basic?.bannerUrl不为空的情况，合成一个新数组
      let list = [];
      this.indexBannerList.forEach(item => {
        if (item?.basic?.bannerUrl) {
          list.push({
            ...(item?.basic || {}),
            enname: item.enname
          });
        }
      });

      // 特殊处理：目前活动后台banner配置没有区分PC和移动端
      if (!this.isLandscape) {
        const replaceBanner = (enname, imgMap, list) => {
          const index = list.findIndex(item => item.enname === enname);
          if (index !== -1) {
            const oldBannerUrl = list[index].bannerUrl;
            const imgMapKeys = Object.keys(imgMap || {}) || [];
            list[index].bannerUrl =
              imgMap[this.lang] ||
              imgMap['en-US'] ||
              imgMap[imgMapKeys?.[0]] ||
              oldBannerUrl ||
              '';
          }
        };
        this.gameInfoConfig?.replaceMobileBanner?.forEach?.(item => {
          replaceBanner(item.enname, item.imgMap, list);
        });
      }

      // 特殊处理：蚂蚁日本下架累充banner
      if (this.gameId == 263 && this.lang === 'ja-JP') {
        list = list.filter(item => item.enname !== 'ltwjyxtc');
      }

      return list;
    }
  },
  watch: {
    showBannerList: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (!newVal.length) return;
        this.$nextTick(() => {
          this.initSwiper();
        });
      }
    }
  },
  methods: {
    jumpLink(link) {
      if (!link) return;
      sdkOpenLink({ link: getGlobalGetGotoLink({ link: link }) });
    },
    initSwiper() {
      try {
        const _self = this;
        const isMulti = this.showBannerList.length > 1;
        this.swiper && this.swiper.destroy();
        this.swiper = new Swiper('.banner-swiper-container', {
          loop: isMulti,
          autoplay: {
            delay: 4000,
            stopOnLastSlide: false,
            disableOnInteraction: false
          },
          pagination: isMulti
            ? {
                el: '.swiper-pagination',
                clickable: true
              }
            : false,
          effect: 'slide',
          observer: true,
          observeParents: true,
          on: {
            slideChange: function () {
              _self.activeIndex = this.realIndex;
            }
          }
        });
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/_dimen.scss';
.cont {
  position: relative;
  &::before {
    z-index: 1;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.5) 0%,
      rgba(0, 0, 0, 0) 100%
    );
  }
}
.banner {
  overflow: hidden;
  position: relative;
  display: block;
  width: 100%;
  height: 322px;

  &-text {
    z-index: 2;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: calc(100% - 80px);
    height: 68px;
    margin: auto;
    padding: 0 100px 0 20px;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 8px 8px 0 0;
    font-size: 22px;
    color: #ffffff;
    text-align: left;

    &-arrow {
      flex-shrink: 0;
      margin-left: 20px;
    }
  }
  &-img {
    width: 100%;
    height: 100%;
    object-fit: cover;

    &.hover {
      cursor: pointer;
    }
  }
}

.swiper-pagination {
  box-sizing: border-box;
  padding: 0 60px;
  text-align: right;
  bottom: 21px;
}

#ssr-page.landscape {
  .banner {
    height: 320px;

    &-text {
      width: 100%;
      max-width: 1507px;
    }
  }
  .swiper-pagination {
    max-width: 1507px;
    left: 0;
    right: 0;
    margin: auto;
    padding: 0 20px;
  }
}
</style>

<style lang="scss">
@import '@assets/scss/officialTopupNew/_dimen.scss';
.swiper-pagination-bullet {
  background: #fff;
  width: 12px;
  height: 12px;
  opacity: 1;
  margin: 0 5px;
}
.swiper-pagination-bullet-active {
  background: $themeColor;
}
</style>
